"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.NavLink = exports.Link = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _internal = require("./internal");

var Link = function Link(_ref) {
  var to = _ref.to,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["to"]);
  return _react.default.createElement("a", (0, _extends2.default)({
    href: to
  }, rest, {
    onClick: function onClick(event) {
      event.preventDefault();
      (0, _internal.navigate)(to);
    }
  }));
};

exports.Link = Link;

var NavLink = function NavLink(_ref2) {
  var to = _ref2.to,
      className = _ref2.className,
      activeClassName = _ref2.activeClassName,
      rest = (0, _objectWithoutProperties2.default)(_ref2, ["to", "className", "activeClassName"]);
  var context = (0, _react.useContext)(_internal.LocationContext);
  var theClassName = to === context.pathname ? activeClassName : className;
  return _react.default.createElement("a", (0, _extends2.default)({
    href: to,
    className: theClassName
  }, rest, {
    onClick: function onClick(event) {
      event.preventDefault();
      (0, _internal.navigate)(to);
    }
  }));
};

exports.NavLink = NavLink;